import { useState, useEffect } from 'react';
import { BrandConfig, ConfigValue } from './configs/types';
import { BRANDING_KEY, BrandConfigurationFiles } from './constants';
import { getProductId } from '~/components/context';
import { PRODUCT_ID } from '~/constants';
import { get } from '~/utils/object';

const loadConfig = async (productId: PRODUCT_ID): Promise<BrandConfig> => {
  const configFileName = BrandConfigurationFiles[productId];
  const { default: config } = await import(
    `./configs/${configFileName}.config.ts`
  );
  return config as BrandConfig;
};

const useBranded = (key: BRANDING_KEY): ConfigValue => {
  const [config, setConfig] = useState<BrandConfig>();
  const productId = getProductId() as PRODUCT_ID;

  useEffect(() => {
    let subscribed = true;
    if (subscribed) {
      loadConfig(productId)
        .then(setConfig)
        .catch(() => setConfig(undefined));
    }
    return () => {
      subscribed = false;
    };
  }, [productId]);

  return get(config, key, undefined);
};

export default useBranded;
